// Actions
import { PushSubRouteAction } from "@ms/planner-actions/lib/local/route/PushSubRouteAction";
import { ReplaceSubRouteAction } from "@ms/planner-actions/lib/local/route/ReplaceSubRouteAction";
// Modules
import { LogicModule } from "@ms/planner-logicmodules/lib/local/modules/LogicModule";
/**
 * Action creator dealing with routing
 */ export class RoutingActionCreator {
    async navigate(routeChangeDescriptor, skipHistoryPushState, interactionDetails) {
        const routingModule = await this.logicModuleLoaders.load(LogicModule.RoutingScenario);
        routingModule.navigate(routeChangeDescriptor, skipHistoryPushState, interactionDetails);
    }
    async navigateToPlan(routingDetails, queryParams) {
        const routingModule = await this.logicModuleLoaders.load(LogicModule.RoutingScenario);
        routingModule.navigateToPlan(routingDetails, queryParams);
    }
    async navigateToPortfolio(routingDetails, queryParams) {
        const routingModule = await this.logicModuleLoaders.load(LogicModule.RoutingScenario);
        routingModule.navigateToPortfolio(routingDetails, queryParams);
    }
    async pushSubRoute(subRoute) {
        await this.dispatcher.dispatchActionAsync(new PushSubRouteAction(subRoute));
    }
    async replaceSubRoute(subRoute) {
        await this.dispatcher.dispatchActionAsync(new ReplaceSubRouteAction(subRoute));
    }
    /**
     * Initializes a new instance of the Router action creator.
     * @param dispatcher The dispatcher the SPA uses to dispatch actions.
     * @param logicModuleLoaders Set of loaders for logic modules
     */ constructor(dispatcher, logicModuleLoaders){
        this.dispatcher = dispatcher;
        this.logicModuleLoaders = logicModuleLoaders;
    }
}
